import { render, staticRenderFns } from "./ExtractFieldEditor.vue?vue&type=template&id=5de97f43&scoped=true"
import script from "./ExtractFieldEditor.vue?vue&type=script&lang=js"
export * from "./ExtractFieldEditor.vue?vue&type=script&lang=js"
import style0 from "./ExtractFieldEditor.vue?vue&type=style&index=0&id=5de97f43&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de97f43",
  null
  
)

export default component.exports